import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { GlobalStyles } from '@nettbureau/styling';
import { useContext, createContext } from 'react';
import { useLocale, I18nProvider } from 'react-aria';
import { createComponent } from './system/factories.js';
import '@react-aria/utils';
import 'ramda';
import { ThemeProvider } from './theming/theme-provider.js';

/**
 * Context providing information about a provider to its children.
 */ const ProviderContext = /*#__PURE__*/ createContext({});
/**
 * Provider component bootstrapping the application with the theme, global styles and locale.
 *
 * @param props - Props for creating the provider component.
 */ const Provider = createComponent((props)=>{
    const { locale: defaultLocale } = useLocale();
    const { children, locale = defaultLocale, theme } = props;
    const parentContext = useContext(ProviderContext);
    return /*#__PURE__*/ jsx(ProviderContext.Provider, {
        value: {
            ...parentContext,
            ...props
        },
        children: /*#__PURE__*/ jsxs(ThemeProvider, {
            ...theme,
            children: [
                /*#__PURE__*/ jsx(GlobalStyles, {
                    background: props.background
                }),
                /*#__PURE__*/ jsx(I18nProvider, {
                    locale: locale,
                    children: children
                })
            ]
        })
    });
});

export { Provider };
//# sourceMappingURL=provider.js.map
